
export const foucsOnElement = (el: any): void => {
    if (!el?.isConnected) return
    try {
        el.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' })
    } catch {
        // Solid Key reconcile can invalidate parent/child; ignore scroll races.
    }
};

export const isVerticallyInViewport = (el: HTMLElement | null): boolean => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top >= 0 && rect.bottom + 100 <= viewportHeight;
};

export const foucsOnElementIfNeeded = (el: HTMLElement | null): void => {
    if (!el?.isConnected || !el.parentNode) return;
    try {
        if (isVerticallyInViewport(el)) {
            el.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        } else {
            el.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
        }
    } catch {
        // Ignore insertBefore / ownership races during swimlane Key updates.
    }
};

export const focusOnElementEnd = (el: any): void => {
    if (!el?.isConnected) return
    try {
        el.scrollIntoView({ block: 'end', inline: 'start', behavior: 'auto' });
    } catch { /* noop */ }
};

export const focusOnElementStart = (el: any): void => {
    if (!el?.isConnected) return
    try {
        el.scrollIntoView({ block: 'start', inline: 'start', behavior: 'auto' });
    } catch { /* noop */ }
};
